module.exports = __webpack_public_path__ + "img/rsz_31credmap_homepage_1.b6189ee7.jpg";